<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Costo de Envío *
      </label>
      <div class="relative">
        <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
        <input 
          :value="modelValue.fee" 
          type="number"
          min="0" 
          step="0.01" 
          required 
          class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
          placeholder="0.00"
          @input="updateField('fee', $event)" 
        >
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Condiciones ({{ operator === 'and' ? 'todas deben cumplirse' : 'al menos una debe cumplirse' }})
      </label>
      <div class="space-y-3">
        <div
          v-for="(condition, index) in modelValue.conditions || []"
          :key="Number(index)"
          class="border border-gray-200 dark:border-gray-600 rounded-lg p-3"
        >
          <div class="flex items-center justify-between mb-2">
            <select 
              :value="condition.type"
              class="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white mr-2"
              @input="updateCondition(Number(index), 'type', $event)"
            >
              <option value="order_total_threshold">
                Umbral de Total
              </option>
              <option value="day_of_week">
                Día de la Semana
              </option>
            </select>
            <button
              type="button"
              class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
              @click="$emit('remove-condition', Number(index))"
            >
              <i class="fas fa-trash" />
            </button>
          </div>

          <div
            v-if="condition.type === 'order_total_threshold'"
            class="mt-2"
          >
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Total Mínimo</label>
            <div class="relative">
              <span class="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
              <input 
                :value="condition.min_order_total" 
                type="number"
                min="0" 
                step="0.01" 
                class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                placeholder="0.00"
                @input="updateCondition(Number(index), 'min_order_total', $event)" 
              >
            </div>
          </div>

          <div
            v-else-if="condition.type === 'day_of_week'"
            class="mt-2"
          >
            <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Día</label>
            <select 
              :value="condition.day"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
              @input="updateCondition(Number(index), 'day', $event)"
            >
              <option value="monday">
                Lunes
              </option>
              <option value="tuesday">
                Martes
              </option>
              <option value="wednesday">
                Miércoles
              </option>
              <option value="thursday">
                Jueves
              </option>
              <option value="friday">
                Viernes
              </option>
              <option value="saturday">
                Sábado
              </option>
              <option value="sunday">
                Domingo
              </option>
            </select>
          </div>
        </div>

        <button
          type="button"
          class="w-full px-3 py-2 border border-dashed border-gray-300 dark:border-gray-600 rounded-lg text-gray-600 dark:text-gray-400 hover:border-gray-400 dark:hover:border-gray-500 transition-colors"
          @click="$emit('add-condition')"
        >
          <i class="fas fa-plus mr-2" />
          Agregar Condición
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: Record<string, any>
  operator: 'and' | 'or'
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: Record<string, any>]
  'add-condition': []
  'remove-condition': [index: number]
}>()

const updateField = (field: string, event: Event) => {
  const target = event.target as HTMLInputElement
  const numValue = parseFloat(target.value) || 0
  emit('update:modelValue', {
    ...props.modelValue,
    [field]: numValue
  })
}

const updateCondition = (index: number, field: string, event: Event | string) => {
  const conditions = [...(props.modelValue.conditions || [])]
  const condition = { ...conditions[index] }
  
  if (typeof event === 'string') {
    condition[field] = event
  } else {
    const target = event.target as HTMLInputElement | HTMLSelectElement
    const value = target.type === 'number' ? (parseFloat(target.value) || 0) : target.value
    condition[field] = value
  }
  
  conditions[index] = condition
  emit('update:modelValue', {
    ...props.modelValue,
    conditions
  })
}
</script>
